import LoginImage from "../../assets/img/skor_login_img.png";
import Logo from "../../assets/img/logo.svg";
import useTranslator from "../../hooks/useTranslator";
import "../onboarding/onboardingProgress.css";

const CheckIcon = () => (
  <svg viewBox="0 0 20 20" aria-hidden="true">
    <path d="m4.5 10.2 3.3 3.3 7.7-7.7" />
  </svg>
);

const TenantChecksSidebar = ({ visibleSteps, activeId }) => {
  const { _t } = useTranslator();
  const sidebarSteps = visibleSteps.filter((s) => !s.hideInSidebar);
  const activeIndex = sidebarSteps.findIndex((s) => s.id === activeId);
  const activeStep = sidebarSteps[activeIndex] || sidebarSteps[0];
  return (
    <aside
      className="onboarding-progress"
      aria-label={_t("yourProcess", "Your process")}
    >
      <img className="onboarding-progress__image" src={LoginImage} alt="" />
      <div className="onboarding-progress__shade" aria-hidden="true" />
      <div className="onboarding-progress__content">
        <img className="onboarding-progress__logo" src={Logo} alt="SKOR" />
        <p className="onboarding-progress__eyebrow">
          {_t("yourProcess", "Your process")}
        </p>
        <ol className="onboarding-progress__steps">
          {sidebarSteps.map((s, i) => {
            const isActive = i === activeIndex;
            const isComplete = i < activeIndex;
            return (
              <li
                key={s.id}
                className={`onboarding-progress__step ${isActive ? "is-active" : isComplete ? "is-complete" : ""}`}
                aria-current={isActive ? "step" : undefined}
              >
                <span className="onboarding-progress__marker">
                  {isComplete ? <CheckIcon /> : i + 1}
                </span>
                <div className="onboarding-progress__step-content">
                  <span className="onboarding-progress__title text-capitalize">
                    {_t(s.titleKey, s.fallback)}
                  </span>
                  {isComplete && (
                    <span className="onboarding-progress__completed">
                      {_t("completed", "Completed")}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ol>

        <div className="onboarding-progress__mobile">
          <img
            className="onboarding-progress__mobile-logo"
            src={Logo}
            alt="SKOR"
          />
          <div className="onboarding-progress__mobile-process">
            <div
              className="onboarding-progress__mobile-track"
              style={{
                left: `${50 / sidebarSteps.length}%`,
                right: `${50 / sidebarSteps.length}%`,
              }}
              aria-hidden="true"
            >
              <span
                style={{
                  width: `${sidebarSteps.length > 1 ? (activeIndex / (sidebarSteps.length - 1)) * 100 : 0}%`,
                }}
              />
            </div>
            <ol
              className="onboarding-progress__mobile-steps"
              style={{
                gridTemplateColumns: `repeat(${sidebarSteps.length}, 1fr)`,
              }}
            >
              {sidebarSteps.map((s, i) => {
                const isActive = i === activeIndex;
                const isComplete = i < activeIndex;
                return (
                  <li
                    key={s.id}
                    className={`${isActive ? "is-active" : ""} ${isComplete ? "is-complete" : ""}`}
                    aria-label={_t(s.titleKey, s.fallback)}
                    aria-current={isActive ? "step" : undefined}
                  >
                    <span>
                      {isComplete ? <CheckIcon /> : <span aria-hidden="true" />}
                    </span>
                  </li>
                );
              })}
            </ol>
            <div
              className="onboarding-progress__mobile-label"
              style={{
                gridTemplateColumns: `repeat(${sidebarSteps.length}, 1fr)`,
              }}
              aria-live="polite"
            >
              <strong style={{ gridColumn: activeIndex + 1 }}>
                {_t(activeStep?.titleKey, activeStep?.fallback)}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
export default TenantChecksSidebar;
